export default "__VITE_ASSET__e7d19c94__"